<template>
  <div v-show="$route.path != '/login'">
    <b-navbar toggleable="lg" style="background-color: #3c8dbc" >
      <b-navbar-brand href="#">
        <b-button v-b-toggle.sidebar-1 size="sm" class="sidebar-1" variant="light">
          <b-icon icon="list"></b-icon>
        </b-button>
      </b-navbar-brand>

        <b-navbar-nav class="ml-auto">
          <b-nav-item right>
            <b-button style="background-color: #3c8dbc; border: none;" class="font-weight-bold" @click="signOut">
              <b-icon icon="box-arrow-right"></b-icon> Sair
            </b-button>
          </b-nav-item>
        </b-navbar-nav>
    </b-navbar>
  </div>
</template>
<script>
import AuthService from '../services/auth'

export default {
  name: "NavbarComponent",
  methods: {
    signOut() {
      AuthService.logout()
      this.$router.push({ path: 'login'})
    }
  }
};
</script>
<style scoped>
  .navbar{
    padding-left: 25px;
    padding-right: 25px;

    display: flex;
    justify-content: space-between;
  }
  .navbar-collapse{
    justify-content: end;
  }
</style>